import { render, staticRenderFns } from "./OrderDetailUFundInfo.vue?vue&type=template&id=cd436f88&scoped=true&"
import script from "./OrderDetailUFundInfo.vue?vue&type=script&lang=js&"
export * from "./OrderDetailUFundInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailUFundInfo.vue?vue&type=style&index=0&id=cd436f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd436f88",
  null
  
)

export default component.exports